import { Component } from '@angular/core';
import { AuthService } from '../../../auth/service/auth.service';
import { AccessLinksService, UpdateAccessLinkRequest } from 'ldt-identity-service-api';
import { NotificationService } from '../../notification-service/notification.service';
import { PeopleReportService } from '../../../people/report-service.service';
import { CompanyInfoService } from '../../company-search/company-info-service.service';
import { MatDialog } from '@angular/material/dialog';
import { TokenInputDialogComponent } from '../token-input-dialog/token-input-dialog.component';

@Component({
    selector: 'app-access-link-cache-update',
    template: `
    <button
      *ngIf="authService.$isAdmin | async"
      mat-stroked-button
      color="primary"
      class="tw-min-w-[180px]"
      (click)="onUpdateCacheClick()"
      [disabled]="isUpdating">
      <span *ngIf="isUpdating">
        <mat-spinner diameter="20" class="tw-inline-block tw-mr-2"></mat-spinner>
        Updating...
      </span>
      <span *ngIf="!isUpdating" class="tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-text-[18px] tw-leading-[18px]">construction</mat-icon>
        Update PAL Cache
      </span>
    </button>
  `,
    styles: [],
    standalone: false
})
export class AccessLinkCacheUpdateComponent {
  isUpdating = false;

  constructor(
    protected authService: AuthService,
    private accessLinksService: AccessLinksService,
    private notificationService: NotificationService,
    private peopleReportService: PeopleReportService,
    private companyInfoService: CompanyInfoService,
    private dialog: MatDialog
  ) {}

  onUpdateCacheClick(): void {
    const dialogRef = this.dialog.open(TokenInputDialogComponent, {
      width: '400px',
      data: {
        title: 'Update Access Link Cache',
        message: 'Enter the access link token to update its cache with current page data.',
        defaultToken: '',
      },
    });

    dialogRef.afterClosed().subscribe((token) => {
      if (token) {
        this.updateAccessLinkCache(token);
      }
    });
  }

  private updateAccessLinkCache(accessLinkToken: string): void {
    this.isUpdating = true;

    // Use getAccessLinkByToken to get the access link directly
    this.accessLinksService
      .listAllAccessLinks(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        1,
        undefined,
        accessLinkToken
      )
      .subscribe({
        next: (res) => {
          const accessLink = res.access_links?.[0];
          if (!accessLink) {
            this.notificationService.error('Access link not found');
            this.isUpdating = false;
            return;
          }

          // Get current cache data
          const currentDataCache = this.peopleReportService.getContextCache();
          const currentCompanyCache = Array.from(this.companyInfoService.getCache().values());

          // Create update request merging existing config with new cache data
          const updateRequest: UpdateAccessLinkRequest = {
            config: {
              ...accessLink.config,
              dataCache: currentDataCache,
              companyCache: currentCompanyCache,
            },
          };

          // Update the access link with new cache data
          const orgId = accessLink.org_id!;
          this.accessLinksService
            .updateAccessLink(orgId, accessLink.id.toString(), updateRequest)
            .subscribe({
              next: () => {
                this.notificationService.success('Access link cache updated successfully');
                this.isUpdating = false;
              },
              error: (error: any) => {
                console.error('Error updating access link cache:', error);
                this.notificationService.error('Failed to update access link cache');
                this.isUpdating = false;
              },
            });
        },
        error: (error: any) => {
          console.error('Error fetching access link:', error);
          this.notificationService.error('Failed to fetch access link data');
          this.isUpdating = false;
        },
      });
  }
}
